import { handleActions } from 'redux-actions';
import * as apiActions from '../actions'; 
import localize from '../../../localization/container';


const defaultState = {
    error: '',
    automationScenarioList: [],
    preUpgrade:"",
    postUpgrade:"",
    jenkinJobStatus:{},
    jobId:''
  
  };

  export const automationResults = handleActions(
    {
      [apiActions.scenarioListSuccess]: (state, action) => {
          return {
            ...state,
            automationScenarioList: action.payload
          };
        },
      [apiActions.fetchTokenFail]: (state, action) => {
          return {
            ...state,
            error: action.payload
          };
        },
        [apiActions.scenarioListUpdate]: (state, action) => {
          let newState = state.automationScenarioList;
          const tempDataObj=action.payload;
          const { jobId, ...noJobId } = tempDataObj;
          let temp=  newState.map(item => item.jobId === action.payload.jobId?{...item, ...noJobId}:item);
          // state.automationScenarioList=[];
          return {...state, automationScenarioList:temp}
        },
        [apiActions.scenarioListUpdateForce]: (state, action) => {
          let newState = state.automationScenarioList;
          const tempDataObj=action.payload;
          const { jobId, ...noJobId } = tempDataObj;
          let temp=  newState.map(item => item.jobId === action.payload.jobId?{...item, ...noJobId}:item);
          // state.automationScenarioList=[];
          return {...state, automationScenarioList:temp}
        },
        [apiActions.jenkinJobStatusSingleRowUpdate]: (state, action) => {
          let newState = {...state};
          const existingRunId = newState.automationScenarioList && newState.automationScenarioList.findIndex(item => item.jobId === action.payload.jobId);
          newState.automationScenarioList[existingRunId]=action.payload;
          state.automationScenarioList=[];
          return {
            ...state,
            automationScenarioList: newState.automationScenarioList
          };
        },
        [apiActions.updateJobStatusSuccess]: (state, action) => {
          return {
            ...state,
            jobId: action.payload
          };
        },
        [apiActions.jenkinsJobPreSuccess]: (state, action) => {
          return {
            ...state,
            preUpgrade: action.payload
          };
        },

        [apiActions.jenkinsJobPostSuccess]: (state, action) => {
          return {
            ...state,
            postUpgrade: action.payload
          };
        },
        [apiActions.scenarioListFail]: (state, action) => ({
          ...state,
          error:'Unable to to fetch data'
          
        }),
    },
    defaultState
  );

